<template>
  <div>
    <section class="gift-region">
      <div class="card-header">
        <div>
          <p class="message">
            {{ projects.name }}

            <span>
              {{
                setSelectionType(projects.selectionType, projects.productsLimit)
              }}
            </span>
            <br class="md:hidden" />
            <span v-if="!isTiersValid && showTierErrors" class="error-text">
              {{
                projects.selectionType === 1 && totalTiersCount === 1
                  ? 'Please select at least one item.'
                  : 'Please select the required number of items.'
              }}
            </span>
          </p>
        </div>
        <div>
          <p
            class="selected-card-counter"
            :class="{
              'error-text': !isTiersValid && showTierErrors
            }"
          >
            <span>{{ selectedItems.length }}/{{ projects.productsLimit }}</span>
            selected
          </p>
        </div>
      </div>
      <!-- Attachments Here -->

      <!-- <div class="border-divider"></div> -->
      <!-- Selections Here -->

      <section
        v-if="projects.products.length > 2"
        class="gift-selections grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
        :class="{ wrapped: projects.products.length > 3 }"
      >
        <div
          v-for="(product, index) in projects.products"
          :key="index"
          class="gift-holder"
        >
          <ProductSelection
            :class="{ inactive: isSelectedItems(product.id) === true }"
            :limit="projects.productsLimit"
            :product="retrieveProductData(product, product.id)"
            :selected="selectedItems"
            :isAddressCollection="true"
            @handleSelectedItem="
              handleSelectedItems(product, projects.productsLimit, product.id)
            "
            @unSelectItem="unSelectItem"
            @updateSelection="updateSelection"
          />
        </div>
      </section>

      <section
        v-else-if="projects.products.length <= 2"
        class="single-select grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
        :class="{ wrapped: projects.products.length > 3 }"
      >
        <div
          v-for="(product, index) in projects.products"
          :key="index"
          class="gift-holder"
        >
          <ProductSelection
            :class="{ inactive: isSelectedItems(product.id) === true }"
            :limit="projects.productsLimit"
            :product="retrieveProductData(product, product.id)"
            :selected="selectedItems"
            :isAddressCollection="true"
            @unSelectItem="unSelectItem"
            @handleSelectedItem="
              handleSelectedItems(product, projects.productsLimit, product.id)
            "
            @updateSelection="updateSelection"
          />
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import { defaultNotFoundImage } from '@/helpers'
import ProductSelection from '../Universal/ProductSelection/AdminOrderTiers.vue'
import { mapState } from 'vuex'
export default {
  components: { ProductSelection },
  props: ['projects', 'totalTiersCount'],
  data() {
    return {
      selectedItems: [],
      isTiersValid: false,
      showTierErrors: false
    }
  },
  computed: {
    isDisabled() {
      const isEmpty = this.selectedItems.some(item => {
        return Object.values(item.option).some(option => {
          return !option.length
        })
      })
      return isEmpty || !this.selectedItems.length
    },
    isValid() {
      if (this.projects.selectionType === 1 && this.selectedItems.length >= 1) {
        return true
      } else if (
        this.projects.selectionType === 2 &&
        this.selectedItems.length === this.projects.productsLimit
      ) {
        return true
      } else {
        return false
      }
    },
    getisTiersValid() {
      return { isValid: this.isTiersValid, tier: this.projects }
    },
    ...mapState({
      projectInfo: state => state.project.projectInfo,
      recipientInfo: state => state.project.recipientInfo
    }),
    getSelectedItems() {
      return this.selectedItems
    }
  },
  mounted() {
    this.checkInLocalStorage()
    this.tiersValidation(false)
    this.$emit('update-is-tiers-valid', this.getisTiersValid)
  },
  watch: {
    selectedItems() {
      this.tiersValidation(false)
      this.$emit('update-is-tiers-valid', this.getisTiersValid)
      this.$emit('update-selected-items', this.getSelectedItems)
    }
  },
  methods: {
    toggleTierErrors() {
      this.showTierErrors = !this.showTierErrors
    },
    unSelectItem(product) {
      const isAlreadySelected = this.selectedItems.find(
        item => item.id === product.id
      )
      if (isAlreadySelected) {
        this.selectedItems = this.selectedItems.filter(
          item => item.id !== product.id
        )
      }
    },
    setSelectionType(type, limit) {
      if (type === 1) {
        return `Choose up to ${limit} ${limit > 1 ? 'items' : 'item'}`
      } else {
        return `Choose exactly ${limit} ${limit > 1 ? 'items' : 'item'}`
      }
    },
    handleSelectedItems(product, limit, id) {
      product.id = id
      const isAlreadySelected = this.selectedItems.find(
        item => item.id === product.id
      )
      product.option = this.handleTransformedOptions(
        product.admin_order_product_option_sets
      )
      if (isAlreadySelected) {
        this.selectedItems = this.selectedItems.filter(
          item => item.id !== product.id
        )
      } else {
        if (this.selectedItems.length === limit) {
          this.selectedItems = [product]
        } else {
          this.selectedItems.push(product)
        }
      }
    },

    retrieveProductData(product, id) {
      const fileType = product.admin_order_product_attachments.length
        ? product.admin_order_product_attachments[0].contentType
        : ''
      return {
        id: id,
        name: product.name,
        origin: 'projects',
        fileType,
        option: product.admin_order_product_option_sets,
        image: this.getImage(product.admin_order_product_attachments),
        description: product.description
      }
    },

    getImage(data) {
      return data.length ? data[0].url : defaultNotFoundImage
    },

    handleTransformedOptions(options) {
      return options.reduce((acc, option) => {
        const key = Object.keys(option)[0]
        const value = Object.values(option)[0]

        if (value.length == 1) {
          acc[key] = value[0]
        } else {
          acc[key] = ''
        }
        return acc
      }, {})
    },
    updateSelection(id, option, value) {
      const product = this.selectedItems.find(item => item.id == id)
      const foundOption = Object.keys(option)[0]

      if (product.option !== undefined) {
        if (product && foundOption) {
          product.option[foundOption] = value
        }
      } else {
        if (product && foundOption) {
          product.option = {}
          product.option[foundOption] = value
        }
      }
    },
    isSelectedItems(id) {
      const isSelected = this.selectedItems.find(product => product.id === id)
      if (
        isSelected === undefined &&
        this.projects.productsLimit === this.selectedItems.length
      ) {
        return true
      }
    },
    checkInLocalStorage() {
      const selectedItem = JSON.parse(
        localStorage.getItem('adminOrderSelectedItems')
      )
      if (selectedItem) {
        selectedItem.forEach(item => {
          this.projects.products.forEach(product => {
            if (item.id === product.id) {
              const isSelected = this.selectedItems.findIndex(
                x => x.id === product.id
              )
              if (isSelected === -1) {
                this.selectedItems.push(item)
              }
            }
          })
        })
      }
    },
    tiersValidation(showTierErrors = true) {
      const { selectionType, productsLimit } = this.projects
      const selectedCount = this.selectedItems.length

      // Determine validation based on selection type and limits
      this.isTiersValid = this.isValidSelection(
        selectionType,
        productsLimit,
        selectedCount
      )
      this.showTierErrors = showTierErrors
    },

    isValidSelection(selectionType, limit, selectedCount) {
      // Choose up to N items
      if (selectionType === 1) {
        if (limit > 1) {
          return selectedCount >= limit
        }
        // Special case for single item selection
        return this.totalTiersCount === 1 ? selectedCount > 0 : true
      }

      // Choose exactly N items
      if (selectionType === 2) {
        return selectedCount === limit
      }

      return true // Default case
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/global.scss';

.gift-region {
  .message {
    text-align: left;
    font-weight: bold;
    font-size: 0.938rem;

    @media (max-width: 576px) {
      font-size: 0.875rem;
    }

    span {
      font-weight: normal;
      padding-left: 0.5rem;

      &.error-text {
        color: #ce3c3c;
        font-weight: bold;
        padding-left: 0;
        font-size: 0.75rem;

        @media (min-width: 576px) {
          padding-left: 0.5rem;
        }
      }
    }
  }

  .border-divider {
    margin-top: 1rem;
    border-bottom: 6px solid $main-5;
  }
}
/* Mobile-first default styles */
.single-select {
  display: grid;
}

.gift-selections {
  display: grid;
  // justify-content: left;
  // grid-template-columns: repeat(2, 1fr);

  .gift-holder {
    margin-bottom: 0rem;
  }
}

/* Small devices (max-width: 575px) */
@media (max-width: 575.98px) {
  .single-select {
    // gap: 145px;
    // padding-bottom: 10rem;
    justify-content: center;
  }
  .gift-selections {
    // padding-bottom: 10rem;
    justify-content: center;
  }
}

/* Medium devices (576px to 767px) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .single-select {
    // padding-bottom: 10rem;
    justify-content: center;
  }
  .gift-selections {
    // padding-bottom: 10rem;
    justify-content: center;
  }
}

/* Large devices (768px and up) */
@media (min-width: 768px) {
  .single-select {
    // padding-bottom: 8rem;
  }
  .gift-selections {
    padding-bottom: 0rem;
  }
}

/* Small devices such as large phones (640px and up) */
// @media only screen and (max-width: 30em) {
//   .gift-selections,
//   .single-select {
//     grid-template-columns: repeat(2, 1fr);
//   }
// }
@media only screen and (min-width: 40em) {
  .gift-selections,
  .single-select {
    // grid-template-columns: repeat(2, 1fr);
  }
}

/* Medium devices such as tablets (768px and up) */
@media only screen and (min-width: 48em) {
  .gift-selections,
  .single-select {
    // grid-template-columns: repeat(3, 1fr);
  }
}

/* Large devices such as laptops (1024px and up) */
@media only screen and (min-width: 64em) {
  .gift-selections,
  .single-select {
    // grid-template-columns: repeat(4, 1fr);
  }
}

/* Largest devices such as desktops (1280px and up) */
@media only screen and (min-width: 80em) {
  .gift-selections,
  .single-select {
    // grid-template-columns: repeat(5, 1fr);
  }
}

.attachments {
  margin-top: 1.25rem;
  gap: 1rem;

  a {
    font-size: 12px;
  }
}

.disabled {
  opacity: 0.9;
  pointer-events: none;
}

.campaign-container {
  height: auto;
  margin: 0 auto;
}

.campaign-card {
  width: 60%;
  margin: 0 auto;
  padding: 2.5rem 0rem;
  padding-bottom: 8rem;
}

.campaign-title {
  font-family: $editorial;
  font-size: 2rem;
  margin-bottom: 1.75rem;
  font-weight: normal;
}

.campaign-subtitle {
  font-size: 1rem;
  text-align: center;
}

.button-region {
  width: 60%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  gap: 2rem;

  .button-holder {
    display: flex;
    align-items: center;

    p {
      color: #ce3c3c;
      font-size: 0.625rem;
      margin-right: 0.5rem;
      font-weight: 700;
    }
  }

  @media (max-width: 575.98px) {
    justify-content: center;
    width: 100%;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    justify-content: center;
    width: 100%;
  }

  p {
    font-size: 0.875rem;
    color: #232220;

    span {
      color: #a09c95;
    }
  }

  .button-gemnote {
    height: 2.5rem;
    width: auto;
    padding: 0 2rem !important;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid $main-5;
  border-bottom: 1px solid $main-5;
  padding: 1rem 2rem;
}

@media (max-width: 575.98px) {
  .gift-holder {
    width: 100% !important;
    flex-basis: 80%;
  }

  .wrapped {
    justify-content: center !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .gift-holder {
    width: 100% !important;
    flex-basis: 80%;
  }

  .wrapped {
    justify-content: center !important;
  }
}

@media screen and (max-width: 1000px) and (min-width: 800px) {
  .campaign-container {
    transition: 1s ease-in;
    padding: 5rem 0rem;
  }

  .campaign-card {
    width: 70%;
    padding: 5rem 0;
  }
}

@media screen and (max-width: 799px) and (min-width: 700px) {
  .campaign-container {
    transition: 1s ease-in;
    padding: 4rem 0rem;
  }

  .campaign-card {
    width: 80%;
    padding: 4rem 0;
  }

  .campaign-info-links {
    gap: 1.5rem;
  }
}

@media screen and (max-width: 699px) and (min-width: 500px) {
  .campaign-container {
    transition: 1s ease-in;
    padding: 3rem 0rem;
  }

  .campaign-card {
    width: 85%;
    padding: 3rem 0;
  }

  .campaign-title {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    padding: 0 1rem;
  }

  .campaign-subtitle {
    padding: 0 1rem;
    font-size: 14px;
  }

  form {
    width: 75%;
    margin: 2rem auto auto auto;
  }

  .inline-inputs {
    flex-wrap: wrap;
    gap: 2rem;
  }

  .inline-inputs > * {
    flex: 0 1 100%;
  }

  .campaign-info-links {
    gap: 1rem;
  }
}

@media screen and (max-width: 499px) and (min-width: 320px) {
  .campaign-container {
    transition: 1s ease-in;
    padding: 2rem 0rem;
  }

  .campaign-card {
    width: 90%;
    padding: 2rem 0;
  }

  .campaign-title {
    font-size: 1rem;
    margin-bottom: 1rem;
    padding: 0 1rem;
  }

  .campaign-subtitle {
    padding: 0 1rem;
    font-size: 11px;
  }

  .card-header {
    padding: 1rem;
  }
}

.link-grid {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 12px;
}

.selected-card-counter {
  font-size: 0.938rem;

  @media (max-width: 576px) {
    font-size: 0.875rem;
  }

  &.error-text {
    color: #ce3c3c;
  }
}

.inactive {
  opacity: 0.6;
}
</style>
